// pages/LoginPage.jsx
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../src/Context/AuthContext';

const TimeSystemLoginPage = ({ portalSettings }) => {
    
    //State Variables
    const { login, isAuthenticated } = useAuth();
    const navigate = useNavigate();
    const [status, setStatus] = useState('Signing you in�');

    //ENV Variables
    const companyName = import.meta.env.VITE_COMPANY_NAME;
    const apiURL = import.meta.env.VITE_API;

    //Set Site Title
    document.title = `${companyName} - Login`;

    useEffect(() => {
        // grab ?token=... from the URL
        const params = new URLSearchParams(window.location.search);
        const token = params.get('token');

        if (!token) {
            setStatus('Missing token.');
            // optional: nav('/login?err=missing_token');
            return;
        }

        // hit the API
        const run = async () => {
            try {
                const resp = await fetch(`${apiURL}/account/TimeSystemLogin?token=${encodeURIComponent(token)}`, {
                    method: 'POST'
                });

                if (!resp.ok) {
                    const msg = await resp.text().catch(() => '');
                    setStatus(`Login failed${msg ? `: ${msg}` : ''}`);
                    navigate('/login');
                    return;
                }

                setStatus('Success. Redirecting�');

                login();
                navigate('/home');
            } catch (e) {
                setStatus('Network error.');
                navigate('/login');d
            }
        };

        run();
    }, [navigate]);

    // intentionally bare UI
    return (
        <div style={{ padding: 24, fontFamily: 'system-ui, sans-serif' }}>
            {status}
        </div>
    );
};

export default TimeSystemLoginPage;
